module.exports = __webpack_public_path__ + "img/5-half-sm.74854a87.jpg";